var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid d-flex flex-column vh-100 p-4" },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "text-center mt-5" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("p", { staticClass: "mt-2" }, [
              _vm._v("\n      Loading preview data...\n    "),
            ]),
          ])
        : _vm.error
        ? _c("div", { staticClass: "text-center p-5" }, [
            _c("div", { staticClass: "alert alert-danger" }, [
              _vm._v("\n      " + _vm._s(_vm.error) + "\n    "),
            ]),
          ])
        : _vm.previews.length
        ? _c("div", { staticClass: "row flex-fill overflow-hidden mx-0" }, [
            _c(
              "div",
              { staticClass: "col-md-9 px-3 mt-3 overflow-auto h-100" },
              [
                _c("div", [
                  _c("div", { staticClass: "card custom-block mt-3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "card-body d-flex justify-content-between",
                      },
                      [
                        _c("div", { staticClass: "align-items-center" }, [
                          _c("h3", { staticClass: "card-title" }, [
                            _vm._v(
                              "\n                Name: " +
                                _vm._s(_vm.creative.name) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "h4",
                            { staticClass: "card-subtitle mb-2 text-muted" },
                            [
                              _vm._v("\n                Status: "),
                              _c(
                                "span",
                                {
                                  class: _vm.walmart.getStatusBadge(
                                    _vm.creative.status
                                  ),
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.creative.status) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    _vm._l(_vm.previews, function (preview, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "mt-3 mb-2 border rounded custom-block p-3",
                        },
                        [
                          _c("h3", [
                            _vm._v(_vm._s(_vm.adUnitTypes[preview.name])),
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              src: preview.image,
                              alt: preview.name || "Preview",
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-3 d-flex flex-column px-3 mt-3 overflow-auto h-100",
              },
              [
                _c("div", { staticClass: "card custom-block mt-3" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v("\n              Actions\n            "),
                        ]),
                        _vm._v(" "),
                        !_vm.userId
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "text-right d-inline-block login-proof",
                                attrs: { href: "/login" },
                              },
                              [_vm._v("\n              Login\n            ")]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary btn-block",
                          on: { click: _vm.copyShareLink },
                        },
                        [
                          _c("i", { staticClass: "fas fa-link mr-1" }),
                          _vm._v(
                            "\n              Copy Share Link\n            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.creative.layout_link && _vm.userId
                      ? _c("div", { staticClass: "mt-2" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-outline-info btn-block d-flex align-items-center justify-content-center",
                              attrs: {
                                href: _vm.creative.layout_link,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-external-link-alt mr-1",
                              }),
                              _vm._v("\n              Layout\n            "),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userId
                      ? _c("div", { staticClass: "mt-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-block",
                              attrs: { disabled: !!_vm.showCommentBox },
                              on: { click: _vm.createComment },
                            },
                            [
                              _c("i", { staticClass: "fas fa-comment mr-1" }),
                              _vm._v("\n              Comment\n            "),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _vm.userId
                  ? _c(
                      "div",
                      { staticClass: "mt-3" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "mb-2",
                            attrs: { switch: "" },
                            model: {
                              value: _vm.showAllComments,
                              callback: function ($$v) {
                                _vm.showAllComments = $$v
                              },
                              expression: "showAllComments",
                            },
                          },
                          [_vm._v("\n          Show all comments\n        ")]
                        ),
                        _vm._v(" "),
                        _c("CommentInput", {
                          ref: "commentInput",
                          attrs: {
                            "comments-collection": _vm.comments,
                            "edited-comment": _vm.editedComment,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "comment-lists" },
                          _vm._l(_vm.comments, function (comment) {
                            return _c("CommentItem", {
                              key: comment.id,
                              attrs: { comment: comment },
                              on: {
                                commentEditorOpen: (comment) => {
                                  _vm.editedComment = comment.comment
                                },
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ])
        : _c("div", { staticClass: "text-center p-5" }, [
            _c("div", { staticClass: "alert alert-warning" }, [
              _vm._v("\n      No previews available for this creative.\n    "),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }